import { render, staticRenderFns } from "./ShowTraining.vue?vue&type=template&id=a0a40444&"
import script from "./ShowTraining.vue?vue&type=script&lang=js&"
export * from "./ShowTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports